// extracted by mini-css-extract-plugin
module.exports = {"topSide":"editact_topSide__1KjiZ","bottomSide":"editact_bottomSide__26G8Q","button":"editact_button__2eKSy"};